import React from 'react';
import { DataLayerId, SupplyShedDriveTime } from '../../lib/types';
import { LayerPickerListbox } from '../shared/LayerPickerListbox';

interface DetailLayerDropdownProps {
  selectedLayer: DataLayerId | null;
  onLayerChange: (layer: DataLayerId) => void;
  millCode: string | null;
  driveTime: SupplyShedDriveTime;
}

// Map-corner control. Thin wrapper around the shared LayerPickerListbox
// so the row markup (provider logo prefix, name, status pill, locality
// pill, metadata subtitle) stays identical to the left-panel picker.
export const DetailLayerDropdown: React.FC<DetailLayerDropdownProps> = (props) => (
  <LayerPickerListbox {...props} variant="compact" />
);
